import { useState, useEffect } from "react";
import { useChicken } from "../../../../providers/ChickenContext";
import { useValue } from "../../../../providers/ValueContext";
import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import SubHeaderPcp from "../../../../Components/ComponentsIndustry/SubHeaderPcp";
import SalesPredctionCard from "../../../../Components/ComponentsIndustry/SalesPredctionCard";
import InputCardPcp from "../../../../Components/ComponentsIndustry/InputCardPcp";
import { useMachinery } from "../../../../providers/MachineryContext";
import axios from "axios";

import { Container, SizeContainer, ContainerInput } from "./style";
import { useUser } from "../../../../providers/UserContext";

const ToolsPcpChicken = () => {
  const { lossesPercentagem, setLossesPercentagem } = useValue();

  const { infoChicken, setInfoChicken, insumosChicken, getChickenStock } = useChicken();
  const { maquinaFrango } = useMachinery()

  let [chickenPrevSales, setChickenPrevSales] = useState(0);
  let [chickenStock, setChickenStock] = useState(0);
  let [costUnit, setCostUnit] = useState(0);
  let [chickenPrevProductions, setChickenPrevProductions] = useState(0);
  let [chickenProductRecipe, setChickenProductRecipe] = useState(0);
  let [priceUnit, setPriceUnit] = useState(0);

  const { user, rodada, industry } = useUser()

  // const storagedUser = JSON.parse(localStorage.getItem('@App:user'));

  function handlePcp() {

    // const data = {
    //   "custoUnitario": costUnit,
    //   "industria": {
    //     "industria": storagedUser.industria.industria,
    //   },
    //   "planejamentoProducao": chickenProductRecipe,
    //   "previsaoPerda": 3,
    //   "previsaoProducao": chickenPrevProductions,
    //   "previsaoVenda": chickenPrevSales,
    //   "produto": {
    //     "produto": 8,
    //   },
    //   "rodada": 1,
    //   "usuario": {
    //     "usuario": storagedUser.usuario
    //   }
    // }

    const data = {
      "custoUnitario": costUnit,
      "industria": {
        industria: industry?.industria
      },
      "planejamentoProducao": chickenProductRecipe,
      "previsaoPerda": lossesPercentagem,
      "previsaoProducao": chickenPrevProductions,
      "previsaoVenda": chickenPrevSales,
      "produto": {
        "produto": 8,
      },
      "rodada": rodada,
      "usuario": user
    }

    axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/cadastrar", data)
      .then(response => fetchPCP())
      .catch(error => console.log(error))

  }


  useEffect(() => {
    if (!industry?.industria) return
    setLossesPercentagem(3 - industry?.funcControleQualidade ?? 0)
  }, [industry])

  useEffect(() => {

    setChickenStock(infoChicken.estoque);

    setCostUnit(
      infoChicken.custoUnitario
    );

    setPriceUnit(
      infoChicken.preco
    );

    setChickenPrevProductions(
      parseFloat((chickenPrevSales - chickenStock) * ((100 - lossesPercentagem) / 100) < 0 ? 0 : Math.round((chickenPrevSales - chickenStock) * ((100 - lossesPercentagem) / 100))).toFixed(2)
    );

    setChickenProductRecipe(
      parseFloat(chickenPrevSales * priceUnit?.toFixed(2))
    );

  }, [
    setInfoChicken,
    setChickenPrevProductions,
    lossesPercentagem,
    chickenPrevSales,
    chickenStock,
    chickenPrevProductions,
    costUnit,
    priceUnit,
    chickenProductRecipe,
    rodada
  ]);

  const fetchPCP = async () => {
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterPCP/${industry?.industria}/${rodada?.rodada}/8`)
      .then((response) => {
        console.log(response.data);
        if (response.data.previsaoVenda) {
          setChickenPrevSales(response.data.previsaoVenda)
        }
      })
  }

  useEffect(() => {
    if (!rodada?.rodada) return
    fetchPCP()
  }, [rodada, industry])

  useEffect(() => {
    getChickenStock()
  })

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/pcp_button.svg"
          title="PCP"
          subTitle="(Planejamento Controle de Produção)"
          style={["selection", "", "", "", ""]}
        />

        <SubHeaderPcp
          style={["", "selection", "", "", ""]}
          product="Frango Inteiro"
          unity="Caixa de 1 Kg"
        />

        {maquinaFrango.amount >= 1 ? (
          <>
            <ContainerInput>
              {insumosChicken?.map((insumo, key) => {
                let imageURL = null
                if (insumo.insumo.nome === "Frango P") {
                  imageURL = "./images/chicken_p.svg"
                } else if (insumo.insumo.nome === "Caixa (Papelão)") {
                  imageURL = "./images/box.svg"
                } else if (insumo.insumo.nome === "Pernil Suíno") {
                  imageURL = "./images/pig.svg"
                }
                return (
                  <InputCardPcp
                    path={imageURL ?? insumo.insumo.urlImagem}
                    title={insumo.insumo.nome}
                    value={`${insumo.quantidade}`}
                  />
                )
              })}

            </ContainerInput>

            <SalesPredctionCard
              state1={chickenStock}
              setState1={setChickenStock}
              state2={chickenPrevProductions}
              setState2={setChickenPrevProductions}
              state3={chickenPrevSales}
              setState3={setChickenPrevSales}
              state4={costUnit}
              setState4={setCostUnit}
              state5={priceUnit}
              total={chickenProductRecipe}
              setTotal={setChickenProductRecipe}
            />

            <FooterButton
              text="Confirmar"
              path="/toolsPcpCutChicken"
              onHandle={() => handlePcp()}
            />
          </>
        ) : (
          <ContainerInput style={{ color: "white", padding: 20, display: "flex", justifyContent: "center", alignItems: "center" }}>

            <div>ADQUIRA O MAQUINÁRIO PARA PRODUZIR ESTE PRODUTO</div>

          </ContainerInput>
        )}


      </SizeContainer>
    </Container>
  );
};
export default ToolsPcpChicken;
